/**
 * MoftakiBotPage — standalone page for the AI chat, accessible from the main nav.
 * Uses negative margins to reclaim AppShell padding for maximum chat space.
 *
 * Access mirrors the backend requireChatAccess gate: per-user CanAccessChat
 * flag, or superadmin. The nav icon is already hidden without access; this
 * guard covers direct-URL entry (RBAC audit F4).
 */
import { Box, Paper, Typography } from '@mui/material';
import { AIChatPanel } from '../admin/AIChatPanel';
import { useAuth } from '../../auth/useAuth';
import { usePermissions } from '../../hooks/usePermissions';

export const MoftakiBotPage = () => {
  const { user } = useAuth();
  const { role } = usePermissions();

  if (!user?.canAccessChat && role !== 'superadmin') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Paper sx={{ p: 4, maxWidth: 420, textAlign: 'center' }}>
          <Typography variant="h6" gutterBottom>Moftaki AI</Typography>
          <Typography color="text.secondary">
            Chat access is not enabled for your account. Contact an administrator.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ mx: -1, height: 'calc(100vh - 80px)', overflow: 'hidden' }}>
      <AIChatPanel fullHeight />
    </Box>
  );
};
